<template>
  <v-card-subtitle class="text-center mt-2">No data available</v-card-subtitle>
</template>
<script>
  export default {
    name: "NoDataAvailableCenter",

  }
</script>